import { render, staticRenderFns } from "./ProfilePane.vue?vue&type=template&id=967499f8"
import script from "./ProfilePane.vue?vue&type=script&lang=js"
export * from "./ProfilePane.vue?vue&type=script&lang=js"
import style0 from "./ProfilePane.vue?vue&type=style&index=0&id=967499f8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports